import React, { useMemo } from 'react';
import { Button, Tooltip } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import useMessageUser from '../../../../../hooks/useMessageUser';
import useExport from '../../../../../hooks/comms/useExport';

interface DownloadTranslatedZipProps {
  selectedRows: any[];
}

const DownloadTranslatedZip: React.FC<DownloadTranslatedZipProps> = ({ selectedRows }) => {
  const { exportZIP, downloading } = useExport();
  const { showMessage } = useMessageUser();

  const translatedRows = useMemo(
    () => selectedRows.filter(r => ['TRANSLATION_COMPLETE', 'APPROVED'].includes(r.communicationStatus)),
    [selectedRows]
  );

  const handleDownload = async () => {
    const requests = translatedRows.map((r: any) => ({
      requestId: r.requestId,
      scNumber: r.ascScNumber,
      spNumber: String(r.assSpNumber),
      communicationType: r.assComType,
      puCode: String(r.ascPuCode),
      referenceNumber: String(r.assRef),
      age: r.age,
      country: r.country,
      no: r.assNo,
    }));
    try {
      await exportZIP('/translations/documents/export/pdf-zip', { requests }, 'traducciones');
    } catch (err: any) {
      showMessage(err?.message || 'Error al descargar el ZIP', 'error');
    }
  };

  const disabled = translatedRows.length === 0;

  return (
    <Tooltip title={disabled ? 'No hay comunicaciones con estado "TRANSLATION_COMPLETE" o "APPROVED" seleccionadas' : `Descargar ${translatedRows.length} PDF(s) traducidos`}>
      <Button
        icon={<FilePdfOutlined />}
        loading={downloading}
        disabled={disabled}
        onClick={handleDownload}
      />
    </Tooltip>
  );
};

export default DownloadTranslatedZip;
